<template>
    <div
        data-testid="empty-feed"
        class="text-center p-8 md:rounded-lg"
    >
        <p class="text-slate-600 pb-6">
            <slot name="header"></slot>
        </p>
        <slot name="image"></slot>
        <h1 class="font-display-4 md:font-display-3 mx-auto my-0 mb-3 max-w-sm md:max-w-lg">
            <slot name="title"></slot>
        </h1>
        <p class="text-lg leading-8 text-slate-600 mx-auto mb-5 md:mb-8 md:text-lg md:px-16 md:max-w-screen-md">
            <slot name="text"></slot>
        </p>
        <slot name="button"></slot>
    </div>
</template>

<script>
export default {
    name: 'EmptyFeed',
};
</script>
